import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notfound',
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.scss']
})
export class NotfoundComponent implements OnInit {

  errortitle="Ops";
  errormessage="Er...";
  errorbutton="!!!";

  constructor
  (
    private router: Router
  ) { }

  ngOnInit(): void 
  {
    this.setErrorMessage();
  }

  goHome()
  {
    this.router.navigateByUrl('/');
  }

  setErrorMessage()
  {
    var locale = this.getUsersLocale("pt");

    switch(locale)
    {
      case "pt":
        this.errortitle = "Ops";
        this.errormessage = "Nada pra mostrar aqui.";
        this.errorbutton = "Página Inicial";
        break;
      case "en":
        this.errortitle = "Ops";
        this.errormessage = "Nothing to show here.";
        this.errorbutton = "Home Page";
        break;
      default:
        this.errortitle = "Ops";
        this.errormessage = "Nothing to show here.";
        this.errorbutton = "Home Page";
        break;
    }
  }

  getUsersLocale(defaultValue: string): string 
  {
    if (typeof window === 'undefined' || typeof window.navigator === 'undefined')
      return defaultValue;

    const wn = window.navigator as any;

    let lang = wn.languages ? wn.languages[0] : defaultValue;

    lang = lang || wn.language || wn.browserLanguage || wn.userLanguage;

    let langString = String(lang);

    let dashIndx = langString.indexOf('-');

    if(dashIndx > -1)
    langString = langString.split('-', 2)[0];

    return langString;
  }
}
